import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "../../components/forms/ConfirmForm";
import {cancelStartDelivery} from "../../actions/SubscriptionApiActions";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

class StartDeliveryFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    return this.props.startSubscriptionDelivery({deliveryId: this.props.deliveryId})
      .then((response) => {
        if (response.data.startSubscriptionDelivery.errors.length <= 0) {
          this.props.cancelStartDelivery();
        } else {
          let errors = createValidationErrors(response.data.startSubscriptionDelivery.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelStartDelivery();
  }

  render() {
    return (
      <Form
        errors={this.state.errors}
        message="Are you sure you manually want to start this delivery? If you do so, then a sales order and payment will be made, it will then be scheduled for shipment with the prep_date specified."
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const START_DELIVERY = gql`
  mutation startSubscriptionDelivery($deliveryId: ID!) {
    startSubscriptionDelivery(deliveryId: $deliveryId) {
      errors { key message }
    }
  }
`;

const withMutation = compose(
  graphql(START_DELIVERY, {
    props: ({ mutate }) => ({
      startSubscriptionDelivery: (data) => mutate({
        variables: data
      })
    })
  })
);

export default connect(null, {cancelStartDelivery})(withMutation(StartDeliveryFormContainer));